import prioritizedUseQueryFuturesHook from './prioritizedUseQueryFuturesHook'

const useQueryFutures = prioritizedUseQueryFuturesHook(1)

export default useQueryFutures
